<div class="header">
	<h6>Internal documents</h6>
</div>

<div class="documents">
	@for (file of (files$ | async); track file.fileUuid) {
		<internal-document-entry [file]="file" [correlationId]="correlationId" (deleteDocumentRequested)="delete($event)" [blockInputs]="blockInputs || !file.canDelete"></internal-document-entry>
	}

	<div class="upload-file">
		<div style="display: flex">
			<div style="margin-right: 10px;">
				<input #fileSelector id="upload-file-button" class="input-file" type="file" (change)="upload($event)" [accept]="AVAILABLE_UPLOAD_FORMATS">
				@if (!blockInputs) {
					<button class="upload-file-button" nbButton outline status="primary"
							(click)="fileSelector.click()">UPLOAD FILE
						<nb-icon status="primary" icon="arrow-upward-outline"></nb-icon>
					</button>
				}
			</div>

			@if (uploadingInProgress) {
				<div class="spinner-section">
					<waiting-spinner [visible]="uploadingInProgress" [waitingText]="'UPLOADING'"></waiting-spinner>
				</div>
			}
			@if (!uploadingInProgress && uploadedComplete) {
				<div class="spinner-section">
					<waiting-spinner [visible]="uploadedComplete" [spinning]="false" [waitingText]="'UPLOADED'" [iconName]="'uploaded'"></waiting-spinner>
				</div>
			}
		</div>

		@if (fileIsTooBig) {
			<div class="validation-message">File is too big, maximum 15MB</div>
		}
		@if (showTooManyFiles$ | async) {
			<div class="validation-message">Too many files, maximum 50</div>
		}
	</div>
</div>
